import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Divider, Typography } from 'antd';
import React from 'react';

import DefaultButton from 'components/atoms/DefaultButton';
import FarmbotIcon from 'components/icons/FarmbotIcon';
import getWhiteLabelConfig from 'utils/get-white-label-config';

import './styles.less';

const { title } = getWhiteLabelConfig();

interface Props {
  onLoginWithPassword: () => void;
  onLoginWithEmailCode: () => void;
}

function LoginChoice({ onLoginWithPassword, onLoginWithEmailCode }: Props): JSX.Element {
  return (
    <div className="LoginChoice">
      <FarmbotIcon style={{ height: 52, marginBottom: 24 }} />
      <Typography.Title level={4}>
        Welcome to {title}
      </Typography.Title>
      <Typography.Text type="secondary" className="LoginChoice-subtitle">
        Choose how you would like to sign in
      </Typography.Text>
      <div className="LoginChoice-buttons">
        <DefaultButton
          type="primary"
          block
          icon={<LockOutlined />}
          onClick={onLoginWithPassword}
        >
          Login with Password
        </DefaultButton>
        <Divider plain>or</Divider>
        <DefaultButton
          type="default"
          block
          icon={<MailOutlined />}
          onClick={onLoginWithEmailCode}
        >
          Send a Login Code to my Email
        </DefaultButton>
      </div>
    </div>
  );
}

export default LoginChoice;
